import React from 'react';

import { ModalStyles as Styled } from './Modal.styles';
import { useClickOutside } from '@mantine/hooks';
import { HudIcon } from '../Icons/HudIcons';

export interface ModalProps extends React.HTMLAttributes<HTMLDivElement> {
  opened?: boolean;
  onClose?: () => void;

  withCloseButton?: boolean;
  withClickOutsideToClose?: boolean;
}

export function Modal({
  opened,
  onClose,
  withCloseButton,
  withClickOutsideToClose,
  children,
  ...rest
}: ModalProps) {
  if (!opened) return null;

  const clickOutsideRef = useClickOutside(() => {
    if (withClickOutsideToClose && onClose) {
      onClose();
    }
  });

  return (
    <Styled.Overlay>
      <Styled.ModalContent {...rest} ref={clickOutsideRef}>
        {withCloseButton && (
          <Styled.CloseButton onClick={onClose} aria-label="Close">
            <HudIcon icon="other.close" size='20px' />
          </Styled.CloseButton>
        )}
        {children}
      </Styled.ModalContent>
    </Styled.Overlay>
  );
}
